import { Text, Inset, StackChildren } from '@doordash/design-language'
import { get, noop } from 'lodash'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as events from '../../../events'
import { applicationCountrySelector } from '../../../selectors'
import AppDownloadButton, {
  AppDownloadOS,
} from '../../atoms/app-download-button'
import InstantDashHelp from '../../molecules/instant-dash-banner/instantDashHelp'
import ScheduleOrientationDetails from '../../molecules/schedule-orientation-details'
import { COUNTRY_SHORTCODES, PR_MARKET_ID } from '../../../constants'
import t from './strings'
import * as Exp from '../../../experimentConstants'

type ScheduledOrientationConfirmationProps = {
  orientation: {
    startTime: string
    address: string
  }
  timezone: string
  uniqueLink: string
  application?: any
  dasherId?: string
  clearOrientation?: () => Promise<any>
  trackOrientationDetailsRendered?: () => Promise<any>
  trackConfirmationPageTapDownloadApp?: () => Promise<any>
  selectedApplicationCountry?: { [k: string]: boolean }
  experiments?: object
}

export class ScheduleOrientationConfirmation extends React.Component<
  ScheduledOrientationConfirmationProps
> {
  public static defaultProps = {
    trackOrientationDetailsRendered: noop,
    trackConfirmationPageTapDownloadApp: noop,
    clearOrientation: noop,
  }
  public componentDidMount() {
    this.props.trackOrientationDetailsRendered()
  }

  enableJapanDxOnboardingV2 = (experiments: object, country: string) => {
    const japanDxOnboardingV2 = get(
      experiments,
      Exp.JAPAN_DX_ONBOARDING_V2,
      false
    )
    return country === COUNTRY_SHORTCODES.JP && japanDxOnboardingV2
  }

  public render() {
    const {
      orientation,
      timezone,
      clearOrientation,
      application,
      uniqueLink,
      dasherId,
      selectedApplicationCountry,
      experiments,
    } = this.props
    const country =
      get(application, 'market', 0) === PR_MARKET_ID
        ? 'PR'
        : application.country
    const showJapanDxOnboardingV2 = this.enableJapanDxOnboardingV2(
      experiments,
      country
    )
    const shouldShowVerifyIdentity =
      !showJapanDxOnboardingV2 && country === COUNTRY_SHORTCODES.JP
    const shouldShowWhatToExpectManager =
      showJapanDxOnboardingV2 || country !== COUNTRY_SHORTCODES.JP
    const shouldShowWhatToBringManager = !showJapanDxOnboardingV2
    return (
      <div>
        <Inset>
          <StackChildren>
            {!application.isOriented && (
              <ScheduleOrientationDetails
                uniqueLink={uniqueLink}
                dasherId={dasherId}
                orientation={orientation}
                timezone={timezone}
                clearOrientation={clearOrientation}
                country={country}
                vehicleType={application.vehicleType}
                shouldShowVerifyIdentity={shouldShowVerifyIdentity}
                shouldShowWhatToExpectManager={shouldShowWhatToExpectManager}
                shouldShowWhatToBringManager={shouldShowWhatToBringManager}
              />
            )}
            {!selectedApplicationCountry.isJP && (
              <React.Fragment>
                <Text
                  weight={Text.Weights.ExtraBold}
                  textTransform={Text.TextTransforms.UpperCase}
                >
                  {t.nextStep()}
                </Text>
                <AppDownloadButton
                  onClick={this.props.trackConfirmationPageTapDownloadApp}
                  tag="a"
                  target="_blank"
                  os={AppDownloadOS.IOS}
                />
                <AppDownloadButton
                  onClick={this.props.trackConfirmationPageTapDownloadApp}
                  tag="a"
                  target="_blank"
                  os={AppDownloadOS.ANDROID}
                />
              </React.Fragment>
            )}
          </StackChildren>
        </Inset>
        {!selectedApplicationCountry.isJP && <InstantDashHelp />}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  selectedApplicationCountry: applicationCountrySelector(state),
  dasherId: state.dasherId,
})

const mapDispatchToProps = {
  trackOrientationDetailsRendered: events.trackOrientationDetailsRendered,
  trackConfirmationPageTapDownloadApp:
    events.trackConfirmationPageTapDownloadApp,
  clearOrientation: actions.clearOrientation,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScheduleOrientationConfirmation)
